import React from "react";
import MoleculeImage from "../../MoleculeImage";

// SAR molecule cell sizes. MoleculeImage takes pixel width/height (not a string),
// so we translate semantic sizes here. Numbers tuned for the dense SAR table layout
// where rows must stay compact and R-group fragments need to be readable but small.
const SIZE_DIMENSIONS = {
  xs:    { width:  80, height:  50 }, // R-group cells in the dense table
  small: { width: 120, height:  70 }, // full-molecule rows (no r_groups decomposition)
  core:  { width: 240, height: 120 }, // core scaffold in the header band
};

export function MoleculeCell({ mol, size = "small", diffMode = false }) {
  // For now, MoleculeImage only supports SMILES rendering.
  // plex_id-only rows render a placeholder until the image server adds plex_id resolution.
  const smiles = mol?.smiles ?? null;
  if (!smiles) {
    return <span className="molecule-cell molecule-cell--missing">—</span>;
  }
  // diffMode is equivalent to normal mode for SMILES-only rendering today.
  // Reserved API surface for future R-group-fragment-only rendering.
  const { width, height } = SIZE_DIMENSIONS[size] || SIZE_DIMENSIONS.small;
  return (
    <span className={`molecule-cell molecule-cell--${size}`}>
      <MoleculeImage
        encoding={smiles}
        width={width}
        height={height}
        disableRotation
      />
    </span>
  );
}
